import {
  COASTLINE_GATEWAY_URL,
  COASTLINE_SERVICE_URL,
  schedulingApiUrl,
  serverUrl,
} from "./config"

const ENV = process.env.REACT_APP_ENV

let setupConfig

if (ENV === "production") {
  setupConfig = {
    slots: `${COASTLINE_GATEWAY_URL}/api/v1/slots`,
    inMarket: `${COASTLINE_GATEWAY_URL}/api/v1/in_market`,
    isochrone: `${COASTLINE_GATEWAY_URL}/api/v1/isochrone`,
    charge: `${COASTLINE_GATEWAY_URL}/charge`,
    createPaymentIntent: `${COASTLINE_GATEWAY_URL}/create-payment-intent`,
    fulfillOrder: `${COASTLINE_GATEWAY_URL}/fulfill-order`,
    emailFromUserId: (userId: string) =>
      `${COASTLINE_GATEWAY_URL}/emailFromUserId/${userId}`,
    slackMessage: `${COASTLINE_GATEWAY_URL}/slackMessage`,
    travelStats: `${COASTLINE_GATEWAY_URL}/travelStats`,
    geocode: `${COASTLINE_GATEWAY_URL}/geocode`,
    geocodeFull: `${COASTLINE_GATEWAY_URL}/geocodeFull`,
    reverseGeocode: `${COASTLINE_GATEWAY_URL}/reverseGeocode`,
    instructors: `${COASTLINE_GATEWAY_URL}/instructors`,
    meetingPoints: `${COASTLINE_GATEWAY_URL}/meeting_points`,
    reviews: `${COASTLINE_GATEWAY_URL}/reviews`,
    reviewAggregates: `${COASTLINE_GATEWAY_URL}/review_aggregates`,
    // TODO: /gc/check is not used anymore, will remove it when all users upgrade to a newer version
    gcCheck: `${COASTLINE_GATEWAY_URL}/gc/check`,
    auditLog: `${COASTLINE_GATEWAY_URL}/audit_log`,
    createUser: `${COASTLINE_GATEWAY_URL}/create_user`,
    updateUserEmail: `${COASTLINE_GATEWAY_URL}/update_user_email`,
    stateFromCity: (city: string) =>
      `${COASTLINE_GATEWAY_URL}/state_from_city/${city}`,
    runningLate: (instructorId: string, lessonId: string) =>
      `${COASTLINE_GATEWAY_URL}/running_late/${instructorId}/${lessonId}`,
    scholarshipApply: `${COASTLINE_GATEWAY_URL}/scholarship_apply`,
    userSearch: `${COASTLINE_GATEWAY_URL}/user_search`,
    instructorBadges: (instructorId: string) =>
      `${COASTLINE_GATEWAY_URL}/instructor_badges/${instructorId}`,
    sendLessonReport: `${COASTLINE_GATEWAY_URL}/send_lesson_report`,
    instructorArrived: (instructorId: string, lessonId: string) =>
      `${COASTLINE_GATEWAY_URL}/instructor_arrived/${instructorId}/${lessonId}`,
    fillAnvilPdf: (templateId: string) =>
      `${COASTLINE_GATEWAY_URL}/fill_anvil_pdf/${templateId}`,
    sharedLessons: `${COASTLINE_GATEWAY_URL}/shared-lessons`,
  }
} else {
  setupConfig = {
    slots: `${schedulingApiUrl}/api/v1/slots`,
    inMarket: `${schedulingApiUrl}/api/v1/in_market`,
    isochrone: `${COASTLINE_SERVICE_URL}/api/v1/isochrone`,
    charge: `${serverUrl}/charge`,
    createPaymentIntent: `${serverUrl}/create-payment-intent`,
    fulfillOrder: `${serverUrl}/fulfill-order`,
    emailFromUserId: (userId: string) =>
      `${serverUrl}/emailFromUserId/${userId}`,
    slackMessage: `${serverUrl}/slackMessage`,
    travelStats: `${serverUrl}/travelStats`,
    geocode: `${serverUrl}/geocode`,
    geocodeFull: `${serverUrl}/geocodeFull`,
    reverseGeocode: `${serverUrl}/reverseGeocode`,
    instructors: `${serverUrl}/instructors`,
    meetingPoints: `${serverUrl}/meeting_points`,
    reviews: `${serverUrl}/reviews`,
    reviewAggregates: `${serverUrl}/review_aggregates`,
    gcCheck: `${serverUrl}/gc/check`,
    auditLog: `${serverUrl}/audit_log`,
    createUser: `${serverUrl}/create_user`,
    updateUserEmail: `${serverUrl}/update_user_email`,
    stateFromCity: (city: string) => `${serverUrl}/state_from_city/${city}`,
    runningLate: (instructorId: string, lessonId: string) =>
      `${serverUrl}/running_late/${instructorId}/${lessonId}`,
    scholarshipApply: `${serverUrl}/scholarship_apply`,
    userSearch: `${serverUrl}/user_search`,
    instructorBadges: (instructorId: string) =>
      `${serverUrl}/instructor_badges/${instructorId}`,
    getAddressCache: `${serverUrl}/get_addresses_cache`,
    sendLessonReport: `${serverUrl}/send_lesson_report`,
    instructorArrived: (instructorId: string, lessonId: string) =>
      `${serverUrl}/instructor_arrived/${instructorId}/${lessonId}`,
    fillAnvilPdf: (templateId: string) =>
      `${serverUrl}/fill_anvil_pdf/${templateId}`,
    sharedLessons: `${serverUrl}/shared-lessons`,
  }
}

const apiConfig = setupConfig

export default apiConfig
